import React,{useEffect} from "react";
import { BsArrowReturnRight } from "react-icons/bs";
import { useSelector } from "react-redux";
import moment from "moment";
import { CURRENCY_FORMAT } from "../../../../utils/helper";
import { getCurrentCurrency } from "../../../../utils/customCurrencyHelper";
import { TranslateText } from "../../../../utils/translation";

const GenerateInvoice = ({ tableOrderDetails, val, customer }) => {
  const { invoicePostData, data } = useSelector((store) => store.order);
  const { hotelDetails } = useSelector((store) => store.login);
  const { name, address, gstIN, contactNumber, emailAddress } =
    hotelDetails || {};
  const { activePosName, activePosId, response } = useSelector(
    (store) => store.posSetting
  );

  const posGstIn = response?.filter((item) => item.id == activePosId)?.[0]
    ?.gstIn;
  const posSettings = response?.filter((item) => item.id == activePosId)?.[0];
  const hsnSac = posSettings?.sac;

  const GSTIN = Boolean(posGstIn) ? posGstIn : gstIN;

  const {
    priceBreakup,
    createdAt,
    invoiceBilledDate,
    total,
    subTotal,
    discount,
    serviceCharge,
    invoiceId,
    taxObjects,
    roundOff,
  } = invoicePostData || {};
  let itemPrice = 0;

  let date = invoiceBilledDate ? invoiceBilledDate : createdAt;

  priceBreakup?.forEach((item) => {
    itemPrice += +item.rate * +item.count;

    item.addOns?.forEach((addOn) => {
      itemPrice += +addOn.price * addOn.count;
    });
  });

  useEffect(() => {
      const style = document.createElement("style");
      style.innerHTML = `
        @media print {
  body,
  .font-tahoma,
  * {
    font-family: Tahoma, system-ui, Helvetica, Arial, sans-serif !important;
  }
}
      `;
      document.head.appendChild(style);
  
      // Cleanup function to remove style on component unmount
      return () => {
        document.head.removeChild(style);
      };
    }, []);

  const { symbol, position } = getCurrentCurrency(hotelDetails?.currency);
  return (
    <div className="relative font-tahoma">
      <div className="left-0 right-0 w-full px-2 top-4  absolute text-[0.82rem] font-medium" ref={val}>
        <div className="text-center">
          {Boolean(hotelDetails?.logo) ? (
            <div className="w-full flex justify-center">
              <img
                className="h-[80px] w-[80px] rounded-[20px]"
                src={hotelDetails?.logo}
                alt=""
              />
            </div>
          ) : (
            <></>
          )}

          <p className="text-semibold text-2xl font-semibold capitalize">
            {name}
          </p>

          <p className="text-semibold font-semibold capitalize">
            {activePosName}{invoicePostData?.roomId && !invoicePostData?.tableId && posSettings?.type === 'Restaurant' && ' - Room Service' }
          </p>
          <p className="text-sm">{address}</p>
          <p className="text-sm">
            {Boolean(contactNumber) && (
              <span className="text-sm">
                <TranslateText textKey={"phone"} namespace="pos" />

                {contactNumber}
              </span>
            )}
          </p>

          {Boolean(emailAddress) && (
            <p className="text-sm">
              <TranslateText textKey={"email"} namespace="pos" />
              {emailAddress}
            </p>
          )}

          {Boolean(GSTIN) && (
            <p className="text-sm">
              <TranslateText textKey={"gstin"} namespace="pos" />

              {GSTIN}
            </p>
          )}

          {Boolean(hsnSac) && (
            <p className="text-sm">
              SAC :
              {hsnSac}
            </p>
          )}

          <p className="text-sm">
            <TranslateText textKey={"invoice"} namespace="pos" />
            {invoiceId}
          </p>

          {/* {invoicePostData?.orderSource?.toLowerCase()?.trim() !==
            activePosName?.toLowerCase()?.trim() && (
            <p className="text-1xl capitalize">
              {invoicePostData?.orderSource ?? ""}
            </p>
          )} */}
        </div>

        {tableOrderDetails?.name && (
          <div>
            <p> {tableOrderDetails?.name}</p>
          </div>
        )}

        {customer?.phoneNumber && (
          <div>
            <p>Mobile No :{customer?.phoneNumber}</p>
          </div>
        )}

        {customer?.company && (
          <div>
            <p>
              <TranslateText textKey={"company"} namespace="pos" />

              {customer?.company}
            </p>
          </div>
        )}

        {customer?.gstIN && (
          <div>
            <p>
              <TranslateText textKey={"company_gstin"} namespace="pos" />
              {customer?.gstIN}
            </p>
          </div>
        )}

        <hr className="border-solid border-b-1 border-black my-2" />
        <div className="flex justify-between">
        {tableOrderDetails.tableNumber && (
          <div className="capitalize">
            {tableOrderDetails?.type} - {tableOrderDetails.tableNumber}
          </div>
        )}

        {tableOrderDetails.numberOfPeople && (
          <div>
            <TranslateText textKey={"no_of_pax"} namespace="pos" />

            {tableOrderDetails.numberOfPeople}
          </div>
        )}
        </div>

        <div className="flex justify-between">
          <p className="text-sm">
            {moment(date).format("Do MMM, YYYY h:mm a")}
          </p>
        </div>
        <hr className="border-solid border-b-1 border-black my-2" />

        <div className="flex justify-between">
          <p className="w-[50%]">
            <TranslateText textKey={"item"} namespace="pos" />
          </p>
          <p className="w-[10%] text-center">
            <TranslateText textKey={"qty"} namespace="pos" />
          </p>
          <p className="w-[20%] text-right">
            <TranslateText textKey={"rate"} namespace="pos" />
          </p>
          <p className="w-[30%] text-right">
            <TranslateText textKey={"amt"} namespace="pos" />
          </p>
        </div>
        <div>
          {priceBreakup?.map((item, index) => {
            return (
              <div key={index} className="mb-[2px]">
                <div className="flex justify-between">
                  <p className="w-[50%] text-left text-semibold">{item.type?.length > 15 ? item?.type.substring(0,15) : item?.type}</p>
                  <p className="w-[10%] text-center">{item.count}</p>
                  <p className="w-[20%] text-center">
                    {CURRENCY_FORMAT(+item.rate)}
                  </p>

                  <p className="w-[25%] text-right">
                    {CURRENCY_FORMAT(+item.rate * +item.count)}
                  </p>
                </div>
                {item.addOns?.map((addon) => {
                  return (
                    <div key={addon.name} className="flex justify-between">
                      <div className="flex">
                        <span className="mt-1">
                          <BsArrowReturnRight className="mr-[2px]" />
                        </span>
                        <span>
                          {addon.name}
                          <TranslateText textKey={"x"} namespace="pos" />

                          {addon.count}
                        </span>
                      </div>
                      <span>
                        {CURRENCY_FORMAT(+addon.price * +addon.count)}
                      </span>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
        <hr className="border-solid border-b-1 border-black my-2" />

        <div className="w-full">
          <div className="flex justify-between mb-3 w-full">
            <p>
              <TranslateText textKey={"amount"} namespace="pos" />
            </p>
            <p>{CURRENCY_FORMAT(itemPrice)}</p>
          </div>
          {Boolean(discount) && (
            <div className="flex justify-between mb-2">
              <p>
                <TranslateText textKey={"discount"} namespace="pos" />
              </p>
              <p>{CURRENCY_FORMAT(discount)}</p>
            </div>
          )}

          <div className="flex justify-between mb-1 w-full">
            <p>
              <TranslateText textKey={"sub_total"} namespace="pos" />
            </p>
            <p>{CURRENCY_FORMAT(subTotal)}</p>
          </div>

          {taxObjects?.map((Obj) => {
            if (Obj?.taxAmount) {
              return (
                <div
                  className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1"
                  key={Obj?.id}
                >
                  <div className="flex gap-2">
                    <p className=" text-[14px]">
                      {Obj?.taxName || "Tax"} ({Obj?.taxPercentage}%)
                    </p>
                  </div>
                  <p className=" text-[14px]">
                    {CURRENCY_FORMAT(Obj?.taxAmount)}
                  </p>
                </div>
              );
            }
            return <></>;
          })}

          {Boolean(+serviceCharge) && (
            <div className="flex justify-between mb-2 w-full">
              <p>
                <TranslateText textKey={"extra_charge"} namespace="pos" />
              </p>
              <p>{CURRENCY_FORMAT(serviceCharge)}</p>
            </div>
          )}

          {roundOff && (<div className="flex justify-between mb-1 w-full">
            <p>
              Round Off
            </p>
            <p>{CURRENCY_FORMAT(roundOff)}</p>
          </div>)}

          <div className="flex justify-between mb-2 text-2xl w-full">
            <p>
              <TranslateText textKey={"bill_total"} namespace="pos" />
            </p>
            <p>
              {`${position === "before" ? symbol : ""} 
              ${CURRENCY_FORMAT(total)} 
              ${position === "after" ? `${symbol}` : ""}`}
            </p>
          </div>

          <hr className="border-solid border-b-1 border-black my-2" />
        </div>

        <div className="flex justify-between">
          <p className="text-sm">
            <TranslateText textKey={"thank_you"} namespace="pos" />
          </p>
          <p className="text-sm">
            <TranslateText textKey={"powered_by_revivo"} namespace="pos" />
          </p>
        </div>
        <div>
          Steward Name : {data && data?.length > 0 && data[0] && data[0]?.stewardNames && data[0].stewardNames.length > 0 && data[0].stewardNames[0] && data[0].stewardNames[0].length > 0 ? data[0].stewardNames[0] : ""}
        </div>
      </div>
    </div>
  );
};

export default GenerateInvoice;
